import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

// Issue 2 — a user who lands on a route their role can't access is auto-redirected to their own
// default/first-accessible menu instead of being stranded on an Access Denied dead-end.
export default function AccessDenied() {
  const nav = useNavigate();
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      let dest = "/app";
      try { dest = (await api.get("/me/home")).data?.route || "/app"; } catch { /* fallback */ }
      if (!alive) return;
      // Avoid a redirect loop if the resolved home is itself the forbidden route.
      if (dest && dest !== window.location.pathname) {
        nav(dest, { replace: true });
      } else {
        setRedirecting(false);
      }
    })();
    return () => { alive = false; };
  }, [nav]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="access-denied-page">
      <div className="max-w-md text-center" data-testid="access-denied">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-red-500/10">
          <ShieldAlert className="h-7 w-7 text-red-600" />
        </div>
        {redirecting ? (
          <p className="mt-2 text-sm text-muted-foreground flex items-center justify-center gap-2" data-testid="access-denied-redirecting">
            <Loader2 className="h-4 w-4 animate-spin" /> Taking you to your dashboard…
          </p>
        ) : (
          <>
            <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground">403 · Unauthorized</p>
            <h1 className="mt-1 font-display text-2xl font-semibold tracking-tight" data-testid="access-denied-title">Access Denied</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              You don't have permission to access this module. Ask your administrator to grant the
              required role or permission in Security Center.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
